Ext.define('SA.ChartExportConfig', {
    extend: 'SA.ExportConfig',

    resource: 'chart',

    constructor({svgPromise}) {
        this.callParent(arguments);

        this.svgPromise = svgPromise;
    },

    async prepare() {
        var viewId = await this.model.getIdPromise(),
            chart = SA.Svg.toXmlString(await this.svgPromise);

        this.params = {viewId, chart, dpi: 300};
        this.limitCheck = SA.LimitCheck.forChart();
    }
});
